import { TransactionTagType } from "@syla/shared/types/models/TransactionBase";
import { StatusOption } from "@syla/shared/types/requests/GetGroupsRequest";
import React from "react";
import { sylaSuggestionsText } from "../../../../atoms/NeedsReview";
import { StandardSelectOption } from "../../../../selector/parts/SelectOption";
import { Selector, SelectorProps } from "../../../../selector/Selector";

type StatusFilterProps = {
  values: StatusOption[];
  onChange: (values: StatusOption[]) => void;
  matchWidth?: boolean;
} & Omit<
  SelectorProps<TransactionTagType>,
  "onChange" | "options" | "values" | "isLoading" | "placeholder"
>;

export function StatusFilter({
  values,
  onChange,
  ...props
}: StatusFilterProps): React.ReactElement {
  return (
    <Selector
      values={values}
      onChange={onChange}
      options={StatusFilterOptions}
      placeholder="Hints"
      enableDeselect
      enableMultiSelect
      moveSelectedToTop
      {...props}
    />
  );
}

const StatusFilterOptions: StandardSelectOption<StatusOption>[] = [
  {
    value: StatusOption.NeedsReview,
    data: {
      label: sylaSuggestionsText,
    },
  },
];
